import CustomerOrderListModelBase from '../_generated/modelBases/customer-order-list-model-base';

export default class CustomerOrderListModel extends CustomerOrderListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
